import { createTheme } from "@mui/material";

export function buildTheme(mode) {
  const dark = mode === "dark";
  return createTheme({
    palette: {
      mode,
      background: { default: dark ? "#0a0e1a" : "#f1f5f9", paper: dark ? "#111827" : "#ffffff" },
      primary: { main: "#3b82f6" },
      error: { main: "#ef4444" },
      warning: { main: "#f59e0b" },
      text: { primary: dark ? "#f1f5f9" : "#0f172a", secondary: dark ? "#94a3b8" : "#64748b" },
      divider: dark ? "#1e293b" : "#e2e8f0",
    },
    typography: {
      fontFamily: "'Outfit', 'Helvetica Neue', sans-serif",
      h6: { fontWeight: 700, letterSpacing: "-0.01em" },
      body2: { fontSize: "0.875rem" },
      caption: { fontSize: "0.8rem" },
    },
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: dark ? "#0f172a" : "#f8fafc",
            color: dark ? "#64748b" : "#94a3b8",
            fontSize: "0.72rem", fontWeight: 700,
            textTransform: "uppercase", letterSpacing: "0.07em",
            borderBottom: `1px solid ${dark ? "#1e293b" : "#e2e8f0"}`,
            padding: "8px 12px", whiteSpace: "nowrap",
          },
          body: {
            borderBottom: `1px solid ${dark ? "#1e293b" : "#f1f5f9"}`,
            padding: "10px 12px", fontSize: "0.875rem",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&:hover": { backgroundColor: dark ? "#1e293b55" : "#e8f0fe" },
            transition: "background-color 0.15s",
            "&:nth-of-type(even)": { backgroundColor: dark ? "#ffffff08" : "#f8fafc" },
          },
        },
      },
      MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            borderColor: dark ? "#1e293b" : "#e2e8f0",
            color: dark ? "#64748b" : "#94a3b8",
            fontSize: "0.78rem", padding: "3px 10px",
            textTransform: "none", fontFamily: "'Outfit', sans-serif",
            "&.Mui-selected": { color: dark ? "#f1f5f9" : "#0f172a", borderColor: "#3b82f6", backgroundColor: dark ? "#1e3a5f44" : "#eff6ff", borderLeftColor: "#3b82f6 !important" },
          },
        },
      },
    },
  });
}
